<script setup lang="ts">
import TypographyComponent from './TypographyComponent.vue'

withDefaults(defineProps<{ value: string | number; isActive: boolean; isDisabled?: boolean }>(), {
  isActive: false,
  isDisabled: false,
})
defineSlots<{ label(): void; count(): void }>()
defineEmits(['onClick'])
</script>

<template>
  <button
    :disabled="isDisabled"
    :class="['filter-button', { 'is-active': isActive }]"
    :name="String(value)"
    @click="() => $emit('onClick', value)"
  >
    <TypographyComponent variant="label-medium" text-truncate>
      <slot name="label" />
    </TypographyComponent>
    <TypographyComponent variant="title-large">
      <slot name="count" />
    </TypographyComponent>
  </button>
</template>

<style scoped lang="scss">
.filter-button {
  padding: 8px 16px;
  border-radius: 16px;
  border: var(--secondary-8) 1px solid;
  background: transparent;
  cursor: pointer;
  transition: background-color var(--transition) ease;

  &.is-active {
    background: var(--surface);
  }
}
</style>
